module.exports = __webpack_public_path__ + "static/media/VidhyaOnline Multi Lingual 1.57fdbb74.png";